/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import React, { Component, createRef, forwardRef } from 'react';

import { connect } from 'react-redux';
import { convertToMaintainData, getMaintainData, viewMore } from 'shared/settings/stateMaintain';
import { Helmet } from 'react-helmet';

import './ViewMoreItems.scss';
import { Dropdown, Form } from 'react-bootstrap';
import { SaleCardViewDataTable } from 'shared/sale-card-view-datatable/SaleCardViewDataTable';
import store from 'features/store';

/**


@Author Karthik

@param

@return html code for view more items

**/

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="form-control d-flex custom-drop-down justify-content-between"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/images/Common/br_down.webp`} alt="drop-down" style={{ width: "10px", position: "absolute", right: "10px", top: "12px" }}></img>
        {/* &#x25bc; */}
    </div>
));

class ViewMoreItems extends Component {
    constructor(props) {
        super(props);
        this.scrollRef = this.props.scrollRef || createRef();
        this.state = {
            pageLoading: true,
            popular: {
                "sort": [{ "field": "bidcount", "direction": "desc" }],
                "filter": [
                    { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                    { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                    { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" }],
                "page": { "size": 48 }
            },
            unique: {
                "sort": [{ "field": "bidcount", "direction": "desc" }],
                "filter": [
                    { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                    /*  { "field": "buynowprice", "value": null, "op": "IS NOT", "join": "AND" }, */
                    { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                    { "field": "coolandunique", "value": 1, "op": "=", "join": "AND" },
                    { "field": "isfeatured", "value": 1, "op": "=", "join": "AND" }
                ],
                "page": { "size": 48 }
            },
            itemsNLP: {
                "data": { "searchtext": null },
                "mode": "NLP"
            },
            itemListdata: false,
            displayData: { header: null, patchData: null },
            NLP: false,
            noData: true,
            viewMoreItemsType: this.props.match.params.type,
            showSearch: true,
            itemDataLoadingStatus: true,
            scrollHeight: 158,
            isVisible: false,
            scrollTo: 0,
            pageClientWidth: 16,

            sortActive: "1",
            showFilterDropDown: false,
            showItems: true,  
            isshippable: false,
            ispickuponly: false,
            topCategories: [],
            mostRelated: [],
            activeCategory: 'ALL',
            activeSubCategory: '',
            activeSubCategoryStatus: false
        };

        this.sortByMenu = {
            "1": "Relevance",
            "2": "Ending First",
            "3": "Item Name A-Z",
            "4": "Item Name Z-A",
            "5": "Newest - Oldest",
            "6": "Oldest - Newest",
        };
    }

    componentDidMount() {
        this.searchValue();
        this.windowWidthGet();
        window.addEventListener('resize', this.headerStickyHandle);
        window.addEventListener("popstate", this.backClicked);
        window.addEventListener('resize', this.windowWidthGet);
    }

    componentDidUpdate(prevProps) {
        // Handle only on :type change (search) in view-more-items
        if (this.props.match.path === "/view-more-items/:type" &&
            prevProps.match.params.type &&
            prevProps.match.params.type !== this.props.match.params.type) {
            this.setState({
                viewMoreItemsType: this.props.match.params.type,
                zipcode:  this.props.location.state,
                showSearch: false,
                itemDataLoadingStatus: false,
                noData: true
            }, () => {
                this.searchValue();
            });
        }
        if (prevProps.nlpSearch !== this.props.nlpSearch) {
            if (this.state.viewMoreItemsType === "item") {
                this.setState({
                    viewMoreItemsType: this.props.match.params.type,
                    zipcode:  this.props.location.state,
                    showSearch: false,
                    itemDataLoadingStatus: false,
                    noData: true
                }, () => {
                    this.searchValue();
                });
            }
        }
        window.addEventListener('resize', this.headerStickyHandle);
        window.addEventListener('resize', this.windowWidthGet);
    }

    /* Called when resize the screen */
    windowWidthGet = () => {
        this.setState({
            innerWidth: window.innerWidth,
            pageClientWidth: this.scrollRef?.current?.clientWidth,
        }, () => {
            if (this.state.innerWidth < 992) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: false } });
            } else if (this.state.innerWidth > 992) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: false, open: false } });
            }
        });
    }

    closeSideBar = () => {
        if (window.innerWidth < 992) {
            store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: false } });
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener("popstate", this.backClicked);
    }

    backClicked = () => {
        this.props.history.push(this.props?.location?.state?.fromComponent ? this.props.location.state.fromComponent : this.props.history.push("/"));
    }

    searchValue = () => {
        switch (this.state.viewMoreItemsType) {
            case 'most-popular':
                this.initialMethod('Most Popular', this.state.popular);
                break;
            case 'cool-and-unique':
                this.initialMethod('Cool And Unique', this.state.unique);
                break;
            default:
                this.setState({
                    itemsNLP: {
                        "data": { "searchtext": this.state.viewMoreItemsType },
                        "mode": "NLP"
                    },
                    NLP: true
                }, () => {
                    // const temp = getMaintainData(viewMore);
                    // if (temp) {
                    //     this.setState({
                    //         ...this.state,
                    //         ...temp,
                    //     });
                    // }

                    this.initialMethod(this.state.viewMoreItemsType, this.state.itemsNLP);
                });
                break;
        }
    }

    initialMethod = (header, patchData) => {
        this.setState({
            displayData: {
                header: header,
                patchData: patchData,
            },
            pageLoading: false,
            showSearch: true,
        });
    }

    getRequiredData = (applyScroll) => {
        if (applyScroll) {
            this.getPreviousValues();
        }
    }

    getPreviousValues = () => {
        const temp = getMaintainData(viewMore);
        if (temp) {
            this.setState({
                ...this.state,
                ...temp,
            }, () => {
                this.scrollToPrevious();
            });
        }
    }

    scrollToPrevious = () => {
        this.scrollRef.current.scrollTo({ top: this.state.scrollTo, left: 0 });
    }

    getItemsList = (event) => {
        this.setState({
            // itemListdata : true,
            noData: event.length === 0,
            // topCategories: event.length === 0 ? [] : event.topCategories.length > 0 ? event.topCategories : this.state.topCategories.length ? this.state.topCategories : [],
            // mostRelated:  event.keywords !== '' ? event.keywords.split(',').map(keyword => keyword.trim()) : this.state.mostRelated.length && !event?.serachFailed ? this.state.mostRelated : [],
            // itemDataLoadingStatus: true,
        }, () => {
            this.headerStickyHandle();
            this.getRequiredData(event.scrollPage);
        });
    }

    back = () => {
        this.props.history.push(this.props?.location?.state?.fromComponent ? this.props.location.state.fromComponent : this.props.history.push("/"));
    }

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    headerStickyHandle = () => {
        const header = document.getElementsByClassName('breadcrumb-section')[0].getBoundingClientRect();
        this.setState({
            scrollHeight: header.bottom,
            pageClientWidth: this.scrollRef.current.clientWidth
        })
    }

    /* Called when scroll content */
    handleScroll = (event) => {
        try {
            const scrollTop = event.target.scrollTop;
            this.setState({
                isVisible: (event.target.scrollHeight / 4) < scrollTop,
                scrollTo: scrollTop,
                pageClientWidth: this.scrollRef.current.clientWidth
            });
        } catch (e) {
            this.setState({
                isVisible: false
            });
        }
    };

    stateMaintenance = () => {
        const data = {
            scrollTo: this.state.scrollTo,
            // showFilterDropDown: this.state.showFilterDropDown,
            // sortActive: this.state.sortActive,
            // ...this.state
        };
        convertToMaintainData(viewMore, data);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.headerStickyHandle);
        window.removeEventListener('resize', this.windowWidthGet);
    }

    sortByChange = (event) => {
        this.setState({
            showSearch: false,
            sortActive: event,
        }, () => {
            const filterValue = {
                "1": { field: "relavance", value: "desc" },
                "2": { field: "itemclosetime", value: "asc" },
                "3": { field: "title", value: "asc" },
                "4": { field: "title", value: "desc" },
                "5": { field: "id", value: "desc" },
                "6": { field: "id", value: "asc" },
                // "6": { field: "bidprice", value: "desc" },
                // "7": { field: "bidprice", value: "asc" },
                "8": { field: "SKU", value: "asc" },
            };

            const value = filterValue[event];
            const final = [{ "field": value.field, "direction": value.value }];

            this.setState({
                itemsNLP: {
                    ...this.state.itemsNLP,
                    "data": {
                        ...this.state.itemsNLP.data,
                        sort: final
                    }
                },
            }, () => {
                this.initialMethod(this.state.viewMoreItemsType, this.state.itemsNLP);
            });
        });
    }

    onChangeCheckbox = (event, value) => {
        this.setState({
            showSearch: false,
            isshippable: event === "isshippable" ? !value : this.state.isshippable,
            ispickuponly: event === "ispickuponly" ? !value : this.state.ispickuponly
        }, () => {
            let itemData = this.state.itemsNLP.data.filter;
            let index = itemData.findIndex(elem => elem.field == "isshippable")
            let value = []
            if (this.state.isshippable) {
                value.push(1);
            }
            if (this.state.ispickuponly) {
                value.push(0);
            }
            if (index > -1) {
                if (value.length > 0) {
                    itemData[index]['value'] = [value];
                } else {
                    itemData.splice(index, 1);
                }
            } else {
                itemData.push({ field: "isshippable", value: [value], op: "IN", join: "AND" });
            }
            this.setState({
                itemsNLP: {
                    ...this.state.itemsNLP,
                    "data": {
                        ...this.state.itemsNLP.data,
                        filter: itemData
                    }
                },
            }, () => {
                this.initialMethod(this.state.viewMoreItemsType, this.state.itemsNLP);
            })
        }
        )
    }

    getAllCategoryData = (data) => {
        this.setState({
            activeCategory: data,
            activeSubCategory: '',
            activeSubCategoryStatus: false
        }, () => {
            this.getCategoryData(data)
        })
    }

    getCategoryData = (data) => {
        this.closeSideBar();
        this.setState({
            showSearch: false,
            itemDataLoadingStatus: false,
            activeCategory: this.state.activeCategory === "ALL" ? data : '',
            activeSubCategory: data != "ALL" ? data : '',
            activeSubCategoryStatus: data != "ALL" ? true : false,
        }, () => {
            let categoryFilter = [];
            categoryFilter.push({ field: "category", value: data, op: "=", join: "AND" });
            
            let searchData = this.state.itemsNLP.data.filter;
            const index = searchData.findIndex(x => x.field === "category");

            if (data === "ALL") {
                if (index == 1) {
                    searchData.splice(index, 1);
                }
                searchData = [...searchData];

                this.setState({
                     itemsNLP: {
                        ...this.state.itemsNLP,
                        "data": {
                            ...this.state.itemsNLP.data,
                            filter: searchData
                        }
                    }
                }, () => {
                    this.initialMethod(this.state.viewMoreItemsType, this.state.itemsNLP);
                });
            } else {
                if (index !== -1) {
                    searchData.splice(index, 1);
                }
                searchData = [...searchData, ...categoryFilter];
    
                this.setState({
                    itemsNLP: {
                        ...this.state.itemsNLP,
                        "data": {
                            ...this.state.itemsNLP.data,
                            filter: searchData
                        }
                    },
                }, () => {
                    this.initialMethod(this.state.viewMoreItemsType, this.state.itemsNLP);
                })
            }
        }) 
    }

    getRelatedItems = (data) => {
        this.setState({
            showSearch: false,
            itemDataLoadingStatus: false,
        })
        let relatedData = this.state.itemsNLP.data.filter;
        const index = relatedData.findIndex(x => x.field === "relavance");
        if (index > -1 && relatedData[0]["value"] != data) {
            relatedData[0]["value"] = data;

            this.setState({
                itemsNLP: {
                   ...this.state.itemsNLP,
                   "data": {
                       ...this.state.itemsNLP.data,
                       filter: relatedData
                   }
               },
               viewMoreItemsType: data
           }, () => {
               this.props.history.replace({pathname: `/view-more-items/${data}`, searchValue: data});
           });
        }
    }

    render() {
        return (
            <div className="view-more-items-main" style={{ ...this.props.style }}>
                <Helmet>
                    <meta name='description' content={this.state.displayData.header ? this.state.displayData.header : "CTBids buyers web app"} />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                </Helmet> 
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> : 
                        <div className="view-more-items">
                            <div className="breadcrumb-section">
                                <div className="back-button-title d-flex align-items-center">
                                    <div className="d-flex align-items-center clickable" onClick={this.back}>
                                        <div className="icon">
                                            <i className="fas fa-angle-left"></i>
                                        </div>
                                        <div className="text" style={{ color: '#A50050'}}>Back</div>
                                    </div>
                                    <div className={`title w-100 ${this.state.NLP ? 'nlp-container' : 'text-center'} h5`}>
                                        {
                                            this.state.NLP ?
                                                <span>Showing results for : <span className="search-nlp">{this.state.displayData.header}</span></span> : <span>{this.state.displayData.header}</span>
                                        }
                                    </div>
                                </div>
                                {/* {this.state.viewMoreItemsType != "most-popular" && this.state.viewMoreItemsType != "cool-and-unique" ?
                                    <div className={`filter-section d-lg-flex align-items-center justify-content-between ${this.state.showFilterDropDown || this.state.innerWidth < 992 ? '' : ''}`}>
                                        <div className="d-flex align-items-center w-50 mobile-view">
                                            <div className="sort-by d-flex align-items-center w-50">
                                                <div className="title w-20">Sort by</div>
                                                <Dropdown onSelect={this.sortByChange} className='w-70'>
                                                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                        <div>
                                                            {this.sortByMenu[this.state.sortActive]}
                                                        </div>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu className="custom-dropdown-menu">
                                                        {
                                                            React.Children.toArray(Object.keys(this.sortByMenu).map(sotyByKey =>
                                                                <Dropdown.Item eventKey={sotyByKey}
                                                                    active={this.state.sortActive === sotyByKey} style={{ width: "300px !important" }}>
                                                                    {this.sortByMenu[sotyByKey]}
                                                                </Dropdown.Item>))
                                                        }
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                            <div className="checkbox-ml-10 w-25">
                                                <div className="d-md-flex">
                                                    <Form.Group className="multiple-checkbox checkbox-bottom mb-0">
                                                        <Form.Check custom type="checkbox" id="isshippable" name="isshippable"  checked={  this.state.isshippable}  label="Shippable" onClick={() => this.onChangeCheckbox('isshippable', this.state.isshippable)} />
                                                    </Form.Group>
                                                </div>
                                            </div>
                                            <div className="checkbox-ml-10 w-25">
                                                <div className="d-md-flex">
                                                    <Form.Group className="multiple-checkbox checkbox-bottom mb-0">
                                                        <Form.Check custom type="checkbox" id="pickuponly" name="ispickuponly" checked={ this.state.ispickuponly}  label="Pick Up Only" onClick={() => this.onChangeCheckbox('ispickuponly', this.state.ispickuponly)} />
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : ''} */}
                            </div>
                            {/* <div className='d-flex view-more-layout'>
                                {this.state.viewMoreItemsType != "most-popular" && this.state.viewMoreItemsType != "cool-and-unique" ?
                                    <div className={`side-bar clickable ${window.innerWidth < 992 ? 'mobile-sidenav' : ''} ${this.props.customSidebar.icon ? this.props.customSidebar.open ? '' : 'd-none' : ''}`} style={{ height: `calc(100% - ${this.state.scrollHeight}px)` }}>
                                        <div className='side-heading'>Categories</div>
                                       {this.state.itemDataLoadingStatus && this.state.topCategories.length > 0 ?  <>
                                        <div className={`top-categories menu-item ${this.state.activeCategory == 'ALL' ? 'menu-item-active' : ''}`} onClick={() => { this.getAllCategoryData('ALL') }}>&ensp;All</div>
                                        {
                                            this.state.topCategories.map((data, index) =>
                                            (
                                                <div className={`d-flex top-categories sub-menu-item ${this.state.activeSubCategoryStatus && this.state.activeSubCategory === data.category ? 'sub-menu-active' : ''}`} key={index}>
                                                    &ensp;<span onClick={() => { this.getCategoryData(data.category) }}>{data.category}&ensp;&#40;{data.categorycount}&#41;</span>
                                                </div>
                                            ))
                                        }
                                        </>: ''}
                                    </div> : ''} */}
                            <div className="scroll-content" style={{ height: `calc(100% - ${this.state.scrollHeight}px)` }} ref={this.scrollRef} onScroll={this.handleScroll}>
                                {
                                    this.state.isVisible ?
                                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                                            <i className="fas fa-arrow-up"></i>
                                        </div> : null
                                }
                                {/* {this.state.viewMoreItemsType != "most-popular" && this.state.viewMoreItemsType != "cool-and-unique" && this.state.itemDataLoadingStatus ?
                                        <div className='d-flex gap-5'>
                                        { this.state.itemListdata  &&  this.state.mostRelated.length > 0 ?
                                            <div className='related-keyword' style={{ color: "#a50050" }}>{!this.state.noData ? 'Bidders also search for :' : 'Are you searching for :'}  </div> 
                                            : ''}
                                            { this.state.itemDataLoadingStatus ? 
                                                this.state.mostRelated.map((related, index) => (
                                                    <div className='related-items related-keyword clickable' style={{ color: "#00334d" }} key={index} onClick={() => {this.getRelatedItems(related)}}>
                                                        {related}
                                                    </div>
                                                )) : ''
                                            } 
                                        </div> : ''} */}
                                    <div className={`d-flex align-items-center justify-content-center ${this.state.noData ? 'h-75' : ''}`}>
                                        <div className="large-screen-width">
                                            {
                                                this.state.showSearch ?
                                                    <SaleCardViewDataTable
                                                        config={{ postData: this.state.displayData.patchData }}
                                                        {...this.props}
                                                        getItemsList={this.getItemsList}
                                                        showMoreButton
                                                        stateMaintenance={this.stateMaintenance}
                                                        addBidCount={this.state.viewMoreItemsType == 'most-popular' ? true : false}>
                                                    </SaleCardViewDataTable>
                                                    : <>
                                                        <div className="text-center no-data-search-icon">
                                                            <i className="fas fa-search fa-3x"></i>
                                                        </div><div className="text-center h4 text-bold">
                                                            No results found
                                                        </div><div className="text-center text-muted h5">
                                                            We couldn't find what you're looking for.
                                                        </div>
                                                    </>
                                            }
                                        {/* </div> */}
                                    </div>
                                </div>
                            </div>       
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(ViewMoreItems);